export const config = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    tenantId: process.env.REACT_APP_AZURE_TENANT_ID,
    redirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI,
    postLogoutRedirectUri: process.env.REACT_APP_AZURE_POST_LOGOUT_REDIRECT_URI,
    scopes: ["openid", "profile", "email", "offline_access"],
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`,
  },
  api: {
    ragChatEndpoint: process.env.REACT_APP_RAG_CHAT_API_ENDPOINT,
    ragUploadEndpoint: process.env.REACT_APP_RAG_UPLOAD_API_ENDPOINT,
    vectorStoreId: process.env.REACT_APP_VECTOR_STORE_ID,
  },
};
